<template>
  <div class="text-justify">
    <p>Vous êtes actuellement connecté au site internet (ci-après, le « Site ») permettant d’accéder à l’outil Check
      Position, auquel vous accédez par l’intermédiaire des adresses suivantes :
      <a href="https://check-position.com" target="_blank">https://check-position.com</a> et
      <a href="https://app.check-position.com" target="_blank">https://app.check-position.com</a>.</p>

    <div class="text-h5 mb-2">1. Éditeur</div>

    <p>Ce Site est édité par l'entreprise MHR Consult, SASU, immatriculée au registre du commerce
      et des sociétés de Paris sous le numéro de SIRET 94972934700011 et ayant son siège social au 14 rue de
      Thionville 75019 Paris.</p>

    <div class="text-h5 mb-2">2. Représentant légal et Directeur de la publication</div>

    <p>Monsieur Michael Elbaz.</p>

    <div class="text-h5 mb-2">3. Hébergement</div>

    <p>Ce Site est hébergé par les hébergeurs suivants :</p>

    <p><strong>VULTR</strong> (marque déposée par la société de droit américain The Constant Company, LLC), dont
      le siège social est situé 319 Clematis Street Suite 900, West Palm Beach, FL 33401, Etats-Unis.
      <p>
        <p>Site Web : <a href="https://www.vultr.com" rel="nofollow" target="_blank">www.vultr.com</a></p>

        <p><strong>AWS</strong> (dénomination sociale : Amazon Web Services, Inc.), société de droit étranger dont
          la succursale en France est dénommée AMAZON WEB SERVICES EMEA SARL, immatriculée au RCS de Nanterre sous
          le numéro 831 001 334, disposant d’un établissement situé Tour Carpe Diem, 31 place des Corolles 92098,
          Paris - La Défense Cedex.
          <p>
            <p>Site Web : <a href="https://www.aws.amazon.com/fr/" rel="nofollow"
                             target="_blank">www.aws.amazon.com/fr/</a></p>

            <p><strong>OVH</strong>, Société par Actions Simplifiée immatriculée au RCS de Lille Métropole sous le
              numéro 424 761 419, ayant sons siège social situé 2 rue Kellermann - 59100 Roubaix..
              <p>
                <p>Site Web : <a href="https://www.ovh.com" rel="nofollow" target="_blank">www.ovh.com</a></p>

                <div class="text-h5 mb-2">4. Service CDN</div>

                <p>Le service CDN (Content Delivery Network) vous est mis à disposition par la société CloudFlare Inc.
                  basé aux États-Unis. Dans le cadre du service CDN, des données de contenu sont traitées sur des
                  serveurs
                  CloudFlare situés dans le monde entier à des fins d’amélioration des performances. De plus, des outils
                  de
                  sécurité et une surveillance du trafic sont mis à votre disposition par CloudFlare Inc., basé aux
                  États-Unis.
                  Les données d’utilisation des visiteurs de site Web sont traitées à cette fin sur les serveurs
                  CloudFlare.</p>

                <div class="text-h5 mb-2">5. Registre de traitement des données personnelles</div>
                <p>Conformément à la loi n°78-17 du 6 janvier 1978 modifiée par le règlement
                  n°2016/679, dit règlement général sur la protection des données (RGPD), les
                  collectes et traitements de données personnelles réalisés par l'entreprise MHR Consult
                  sont conformes au RGPD et au registre interne des activités de traitement des
                  données personnelles élaboré par la société.</p>

                <div class="text-h5 mb-2">6. Données personnelles</div>
                <p>Les données personnelles que nous pourrions être amenés à recueillir sont
                  exclusivement destinées à l'entreprise MHR Consult pour vous permettre de profiter des Services
                  offerts par le Site. Aucune information personnelle vous concernant n’est cédée à
                  des tiers ou utilisée à des fins non prévues.</p>

                <p>Vous disposez d’un droit d’accès, de modification, de rectification et de suppression
                  des données personnelles que nous pourrions être amenés à recueillir
                  conformément à la loi n°78-17 du 6 janvier 1978 modifiée et au règlement
                  n°2016/679, dit règlement général sur la protection des données (RGPD).
                  Pour l’exercer, adressez-vous à :</p>

                <p class="text-center font-weight-bold">
                  Entreprise MHR Consult<br/>
                  14 rue de Thionville<br/>
                  75019 Paris<br/>
                </p>

                <div class="text-h5 mb-2">7. Titulaire des droits de propriété intellectuelle</div>
                <p>L'entreprise MHR Consult est titulaire des droits de propriété intellectuelle tant de la
                  structure générale du Site Internet que de son contenu (textes, slogans, outils,
                  images, vidéos, photos et autres contenus). Toute reproduction, utilisation, même
                  partielle est interdite sans autorisation conformément au Code de la propriété
                  intellectuelle.</p>

                <div class="text-h5 mb-2">8. Réalisation du Site et de l’outil Check Position</div>
                <p>Conception technique, design et développement : l'entreprise MHR Consult.</p>

                <div class="text-h5 mb-2">9. Environnement technique</div>
                <p>Ce Site met en œuvre les technologies web usuellement utilisées.</p>

                <div class="text-h5 mb-2">10. Mises à jour</div>
                <p>L'entreprise MHR Consult se réserve le droit de mettre à jour la présente notice légale d’information
                  à tout moment.
                  <p>

                    <p>L'entreprise MHR Consult invite donc les utilisateurs à visiter cette page lors de chaque
                      consultation
                      du Site afin d’en prendre connaissance.</p>

                    <p class="text-center">
                      Dernière mise à jour : 27/01/2025
                    </p>
  </div>
</template>

<script>
export default {
  name: 'LegalNotice'
}
</script>